import apiBase from "./apiBase";

export default {
  loginKiosk: async (userName, password, serialNumber, uniqueId) => {
    const params = {
      Username: userName,
      Password: password,
      KioskApiKey: serialNumber,
      UniqueId: uniqueId,
      LoginType: "D",
    };

    let response = await apiBase.callService(
      "Authenticate/loginKiosk",
      params,
      apiBase.methodTypes.post
    );

    return response.data;
  },
  remoteLogin: async (userName, password, uniqueId) => {
    const params = {
      Username: userName,
      Password: password,
      UniqueId: uniqueId,
      LoginType: "D",
    };
    let response = await apiBase.callService(
      "Authenticate/remoteLogin",
      params,
      apiBase.methodTypes.post
    );

    return response.data;
  },
  getExamineeFromUniqueId: async (uniqueId) => {
    const url = `Authenticate/uniqueIdExamineeAssigned?uniqueId=${uniqueId}`;
    let response = await apiBase.callService(
      url,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
  logout: async () => {
    const url = "Authenticate/logout";
    await apiBase.callService(url, null, apiBase.methodTypes.post);
  },
};
